import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import {
  QaroniViewsArray,
  QaroniViewsEnum,
  QaroniViewsEnumType,
} from '@qaroni-shared/types/qaroni-views.enum';

@Component({
  selector: 'qaroni-toggle-view',
  templateUrl: './toggle-view.component.html',
  styleUrl: './toggle-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleViewComponent extends QarepaBaseSubsDirective {
  readonly selectedView = input<QaroniViewsEnumType>(QaroniViewsEnum.LIST);
  readonly listViewTooltip = input<string>($localize`Ver como lista`);
  readonly gridViewTooltip = input<string>($localize`Ver como cuadrícula`);

  readonly viewChange = output<QaroniViewsEnumType>();

  public control = new FormControl<QaroniViewsEnumType>(QaroniViewsEnum.LIST);
  public views = QaroniViewsEnum;
  public viewsArray = QaroniViewsArray;

  constructor() {
    super();

    this.subs.add(this.control.valueChanges.subscribe(this.getViewChange));

    effect(() => {
      const selected = this.selectedView();
      this.control.setValue(selected, { emitEvent: false });
    });
  }

  public getTooltipText(view: QaroniViewsEnumType): string {
    return view === QaroniViewsEnum.LIST
      ? this.listViewTooltip()
      : this.gridViewTooltip();
  }

  private getViewChange = (view: QaroniViewsEnumType) => {
    this.viewChange.emit(view);
  };
}
